module.exports = [
    { selector: "html", declarations: { display: "block" } },
    { selector: "address", declarations: { display: "block" } },
    { selector: "body", declarations: { display: "block" } },
    { selector: "dd", declarations: { display: "block" } },
    { selector: "div", declarations: { display: "block" } },
    { selector: "dl", declarations: { display: "block" } },
    { selector: "dt", declarations: { display: "block" } },
    { selector: "fieldset", declarations: { display: "block" } },
    { selector: "form", declarations: { display: "block" } },
    { selector: "frame", declarations: { display: "block" } },
    { selector: "frameset", declarations: { display: "block" } },
    { selector: "h1", declarations: { display: "block" } },
    { selector: "h2", declarations: { display: "block" } },
    { selector: "h3", declarations: { display: "block" } },
    { selector: "h4", declarations: { display: "block" } },
    { selector: "h5", declarations: { display: "block" } },
    { selector: "h6", declarations: { display: "block" } },
    { selector: "noframes", declarations: { display: "block" } },
    { selector: "ol", declarations: { display: "block" } },
    { selector: "p", declarations: { display: "block" } },
    { selector: "ul", declarations: { display: "block" } },
    { selector: "center", declarations: { display: "block" } },
    { selector: "dir", declarations: { display: "block" } },
    { selector: "hr", declarations: { display: "block" } },
    { selector: "menu", declarations: { display: "block" } },
    { selector: "pre", declarations: { display: "block" } },
    { selector: "blockquote", declarations: { display: "block" } },
    { selector: "li", declarations: { display: "list-item" } },
    { selector: "head", declarations: { display: "none" } },
    { selector: "table", declarations: { display: "table" } },
    { selector: "tr", declarations: { display: "table-row" } },
    { selector: "thead", declarations: { display: "table-header-group" } },
    { selector: "tbody", declarations: { display: "table-row-group" } },
    { selector: "tfoot", declarations: { display: "table-footer-group" } },
    { selector: "col", declarations: { display: "table-column" } },
    { selector: "colgroup", declarations: { display: "table-column-group" } },
    { selector: "th", declarations: { display: "table-cell" } },
    { selector: "td", declarations: { display: "table-cell" } },
    { selector: "caption", declarations: { display: "table-caption" } },
    { selector: "th", declarations: { "font-weight": "bolder", "text-align": "center" } },
    { selector: "caption", declarations: { "text-align": "center" } },
    { selector: "body", declarations: { margin: "8px" } },
    { selector: "h1", declarations: { "font-size": "2em", margin: ".67em 0" } },
    { selector: "h2", declarations: { "font-size": "1.5em", margin: ".75em 0" } },
    { selector: "h3", declarations: { "font-size": "1.17em", margin: ".83em 0" } },
    { selector: "p", declarations: { margin: "1.12em 0" } },
    { selector: "blockquote", declarations: { margin: "1.12em 0" } },
    { selector: "ul", declarations: { margin: "1.12em 0" } },
    { selector: "fieldset", declarations: { margin: "1.12em 0" } },
    { selector: "form", declarations: { margin: "1.12em 0" } },
    { selector: "ol", declarations: { margin: "1.12em 0" } },
    { selector: "dl", declarations: { margin: "1.12em 0" } },
    { selector: "dir", declarations: { margin: "1.12em 0" } },
    { selector: "menu", declarations: { margin: "1.12em 0" } },
    { selector: "h4", declarations: { margin: "1.12em 0" } },
    { selector: "h5", declarations: { "font-size": ".83em", margin: "1.5em 0" } },
    { selector: "h6", declarations: { "font-size": ".75em", margin: "1.67em 0" } },
    { selector: "h2", declarations: { "font-weight": "bolder" } },
    { selector: "strong", declarations: { "font-weight": "bolder" } },
    { selector: "h4", declarations: { "font-weight": "bolder" } },
    { selector: "h5", declarations: { "font-weight": "bolder" } },
    { selector: "h6", declarations: { "font-weight": "bolder" } },
    { selector: "b", declarations: { "font-weight": "bolder" } },
    { selector: "h1", declarations: { "font-weight": "bolder" } },
    { selector: "h3", declarations: { "font-weight": "bolder" } },
    { selector: "blockquote", declarations: { "margin-left": "40px", "margin-right": "40px" } },
    { selector: "i", declarations: { "font-style": "italic" } },
    { selector: "cite", declarations: { "font-style": "italic" } },
    { selector: "em", declarations: { "font-style": "italic" } },
    { selector: "var", declarations: { "font-style": "italic" } },
    { selector: "address", declarations: { "font-style": "italic" } },
    { selector: "pre", declarations: { "font-family": "monospace" } },
    { selector: "tt", declarations: { "font-family": "monospace" } },
    { selector: "code", declarations: { "font-family": "monospace" } },
    { selector: "kbd", declarations: { "font-family": "monospace" } },
    { selector: "samp", declarations: { "font-family": "monospace" } },
    { selector: "pre", declarations: { "white-space": "pre" } },
    { selector: "button", declarations: { display: "inline-block" } },
    { selector: "select", declarations: { display: "inline-block" } },
    { selector: "textarea", declarations: { display: "inline-block" } },
    { selector: "input", declarations: { display: "inline-block" } },
    { selector: "big", declarations: { "font-size": "1.17em" } },
    { selector: "sub", declarations: { "font-size": ".83em" } },
    { selector: "small", declarations: { "font-size": ".83em" } },
    { selector: "sup", declarations: { "font-size": ".83em" } },
    { selector: "sub", declarations: { "vertical-align": "sub" } },
    { selector: "sup", declarations: { "vertical-align": "super" } },
    { selector: "table", declarations: { "border-spacing": "2px" } },
    { selector: "thead", declarations: { "vertical-align": "middle" } },
    { selector: "tbody", declarations: { "vertical-align": "middle" } },
    { selector: "tfoot", declarations: { "vertical-align": "middle" } },
    { selector: "tr", declarations: { "vertical-align": "inherit" } },
    { selector: "td", declarations: { "vertical-align": "inherit" } },
    { selector: "th", declarations: { "vertical-align": "inherit" } },
    { selector: "del", declarations: { "text-decoration": "line-through" } },
    { selector: "strike", declarations: { "text-decoration": "line-through" } },
    { selector: "s", declarations: { "text-decoration": "line-through" } },
    { selector: "hr", declarations: { border: "1px inset" } },
    { selector: "ul", declarations: { "margin-left": "40px" } },
    { selector: "dir", declarations: { "margin-left": "40px" } },
    { selector: "dd", declarations: { "margin-left": "40px" } },
    { selector: "ol", declarations: { "margin-left": "40px" } },
    { selector: "menu", declarations: { "margin-left": "40px" } },
    { selector: "ul", declarations: { "margin-top": "1em", "margin-bottom": "1em" } },
    { selector: "ol", declarations: { "margin-top": "1em", "margin-bottom": "1em" } },
    { selector: "ul", declarations: { "list-style-type": "disc" } },
    { selector: "ol", declarations: { "list-style-type": "decimal" } },
    { selector: "ins", declarations: { "text-decoration": "underline" } },
    { selector: "u", declarations: { "text-decoration": "underline" } },
    { selector: "center", declarations: { "text-align": "center" } },
    { selector: "h1", declarations: { "page-break-before": "always" } },
    { selector: "h2", declarations: { "page-break-after": "avoid" } },
    { selector: "h1", declarations: { "page-break-after": "avoid" } },
    { selector: "h3", declarations: { "page-break-after": "avoid" } },
    { selector: "h4", declarations: { "page-break-after": "avoid" } },
    { selector: "h5", declarations: { "page-break-after": "avoid" } },
    { selector: "h6", declarations: { "page-break-after": "avoid" } },
    { selector: "ul", declarations: { "page-break-before": "avoid" } },
    { selector: "ol", declarations: { "page-break-before": "avoid" } },
    { selector: "dl", declarations: { "page-break-before": "avoid" } },
    { selector: "figure", declarations: { display: "block" } },
    { selector: "nav", declarations: { display: "block" } },
    { selector: "main", declarations: { display: "block" } },
    { selector: "hgroup", declarations: { display: "block" } },
    { selector: "footer", declarations: { display: "block" } },
    { selector: "section", declarations: { display: "block" } },
    { selector: "header", declarations: { display: "block" } },
    { selector: "article", declarations: { display: "block" } },
    { selector: "aside", declarations: { display: "block" } },
    { selector: "dialog", declarations: { display: "block" } },
    { selector: "figcaption", declarations: { display: "block" } },
    { selector: "mark", declarations: { background: "#FF0", color: "#000" } },
    { selector: "template", declarations: { display: "none" } },
    { selector: "pdf-columns", declarations: { display: "block" } },
    { selector: "pdf-page-content", declarations: { display: "block" } },
    { selector: "ul ul", declarations: { "margin-top": "0", "margin-bottom": "0" } },
    { selector: "ul ol", declarations: { "margin-top": "0", "margin-bottom": "0" } },
    { selector: "ol ul", declarations: { "margin-top": "0", "margin-bottom": "0" } },
    { selector: "ol ol", declarations: { "margin-top": "0", "margin-bottom": "0" } },
    { selector: "br:before", declarations: { content: '"\\A"', "white-space": "pre-line" } },
    { selector: ":visited", declarations: { "text-decoration": "underline" } },
    { selector: ":link", declarations: { "text-decoration": "underline" } },
    { selector: ":focus", declarations: { outline: "thin dotted invert" } },
];
//# sourceMappingURL=module.js.map